export default {
    checkSignUp: (data) => window.axios.post('registration',data)
}